<template>
    <div>
        <HeaderBg :title="$t('adminContactData.title')" />

        <div class="form_container">
            <form @submit.prevent="addContact">
                <!-- Existing Inputs -->
                <div class="input_container">
                    <label>{{$t('adminContactData.phone')}}</label>
                    <input type="text" v-model="contact.phone" />
                </div>

                <div class="input_container">
                    <label>{{$t('adminContactData.email')}}</label>
                    <input type="text" v-model="contact.email" />
                </div>

                <div class="input_container">
                    <label>{{$t('adminContactData.licenseNumber')}}</label>
                    <input type="text" v-model="contact.license_number" />
                </div>

                <div class="input_container">
                    <label>{{$t('adminContactData.sfdaNumber')}}</label>
                    <input type="text" v-model="contact.sfda_number" />
                </div>

                <div class="input_container">
                    <label>{{$t('adminContactData.tayiqUrl')}}</label>
                    <input type="text" v-model="contact.tayiq_url" />
                </div>

                <div class="input_container">
                    <label>{{$t('adminContactData.xUrl')}}</label>
                    <input type="text" v-model="contact.x_url" />
                </div>

                <div class="input_container">
                    <label>{{$t('adminContactData.facebookUrl')}}</label>
                    <input type="text" v-model="contact.facebook_url" />
                </div>

                <div class="input_container">
                    <label>{{$t('adminContactData.instagramUrl')}}</label>
                    <input type="text" v-model="contact.instagram_url" />
                </div>

                <!-- NEW URL Inputs -->
                <div class="input_container">
                    <label>{{$t('adminContactData.snapchatUrl')}}</label>
                    <input type="text" v-model="contact.snapchat_url" />
                </div>
                <!-- NEW Activation Selects -->
                <div class="input_container">
                    <label>{{$t('adminContactData.activeSnapchat')}}</label>
                    <select v-model.number="contact.active_snapchat">
                        <option :value="1">{{$t('adminContactData.statusActive')}}</option>
                        <option :value="0">{{$t('adminContactData.statusInactive')}}</option>
                    </select>
                </div>
                <div class="upload_img">
                    <span>{{$t('adminContactData.snapchatIcon')}}</span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="!snapchatImgUrl" />
                        <img :src="snapchatImgUrl" alt="" v-else />
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label>
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" @change="uploadSnapchatImgUrl" />
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="input_container">
                    <label>{{$t('adminContactData.tiktokUrl')}}</label>
                    <input type="text" v-model="contact.tiktok_url" />
                </div>
                <div class="input_container">
                    <label>{{$t('adminContactData.activeTiktok')}}</label>
                    <select v-model.number="contact.active_tiktok">
                        <option :value="1">{{$t('adminContactData.statusActive')}}</option>
                        <option :value="0">{{$t('adminContactData.statusInactive')}}</option>
                    </select>
                </div>
                <div class="upload_img">
                    <span>{{$t('adminContactData.tiktokIcon')}}</span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="!tiktokImgUrl" />
                        <img :src="tiktokImgUrl" alt="" v-else />
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label>
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" @change="uploadTiktokImgUrl" />
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="input_container">
                    <label>{{$t('adminContactData.youtubeUrl')}}</label>
                    <input type="text" v-model="contact.youtube_url" />
                </div>
                <div class="input_container">
                    <label>{{$t('adminContactData.activeYoutube')}}</label>
                    <select v-model.number="contact.active_youtube">
                        <option :value="1">{{$t('adminContactData.statusActive')}}</option>
                        <option :value="0">{{$t('adminContactData.statusInactive')}}</option>
                    </select>
                </div>

                <!-- Uploads -->
                <div class="upload_img">
                    <span>{{$t('adminContactData.youtubeIcon')}}</span>
                    <div class="img_container">
                        <img src="../../../assets/images/replaceImg.svg" alt="" v-if="!youtubeImgUrl" />
                        <img :src="youtubeImgUrl" alt="" v-else />
                        <div class="photo_upload">
                            <div class="upladImg">
                                <div class="upload">
                                    <label>
                                        <img src="../../../assets/images/inputFile.svg" alt="">
                                        <input type="file" @change="uploadYoutubeImgUrl" />
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                

                

                <!-- Alerts -->
                <div class="alert alert-success mt-2" role="alert" v-if="successMessage">
                    {{$t('adminContactData.successMessage')}}
                </div>

                <div class="alert alert-danger mt-2" role="alert" v-if="ErrorCheck">
                    <p v-for="(error, index) in errors" :key="index">{{ error }}</p>
                </div>

                <!-- Submit -->
                <button class="saveBtn" v-if="!postLoaded">{{$t('adminContactData.save')}}</button>
                <button class="saveBtn" v-else><b-spinner></b-spinner></button>
            </form>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import HeaderBg from "../../global/HeaderBg/HeaderBg";
import Request from "../../../services/Request";

export default {
    name: "AddContactsData",
    components: { HeaderBg },
    data() {
        return {
            postLoaded: false,
            successMessage: false,
            contact: {
                phone: "",
                email: "",
                license_number: "",
                sfda_number: "",
                tayiq_url: "",
                x_url: "",
                facebook_url: "",
                instagram_url: "",
                snapchat_url: "",
                tiktok_url: "",
                youtube_url: "",
                active_snapchat: 0,
                active_tiktok: 0,
                active_youtube: 0,
            },
            youtubeFile: null,
            snapchatFile: null,
            tiktokFile: null,
            youtubeImgUrl: "",
            snapchatImgUrl: "",
            tiktokImgUrl: "",
            errors: [],
            ErrorCheck: false,
        };
    },
    mounted() {
        this.getContacts();
    },
    methods: {
        uploadYoutubeImgUrl(e) {
            this.youtubeFile = e.target.files[0];
            this.youtubeImgUrl = URL.createObjectURL(e.target.files[0]);
        },
        uploadSnapchatImgUrl(e) {
            this.snapchatFile = e.target.files[0];
            this.snapchatImgUrl = URL.createObjectURL(e.target.files[0]);
        },
        uploadTiktokImgUrl(e) {
            this.tiktokFile = e.target.files[0];
            this.tiktokImgUrl = URL.createObjectURL(e.target.files[0]);
        },

        addContact() {
    this.postLoaded = true;
    this.successMessage = false;
    this.errors = [];
    this.ErrorCheck = false;

    const formData = new FormData();

    // Append only normal text fields, skip icons
    for (const key in this.contact) {
        if (
            key !== "snapchat_icon" &&
            key !== "youtube_icon" &&
            key !== "tiktok_icon"
        ) {
            formData.append(key, this.contact[key]);
        }
    }

    // Append images only if uploaded
    if (this.youtubeFile instanceof File) {
        formData.append("youtube_icon", this.youtubeFile);
    }
    if (this.snapchatFile instanceof File) {
        formData.append("snapchat_icon", this.snapchatFile);
    }
    if (this.tiktokFile instanceof File) {
        formData.append("tiktok_icon", this.tiktokFile);
    }

    axios
        .post("https://app.almujtama.com.sa/admin/website_contacts", formData, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
                "Content-Type": "multipart/form-data",
            },
        })
        .then(() => {
            this.successMessage = true;
            this.postLoaded = false;
        })
        .catch((err) => {
            this.errors = err.response?.data?.errors || ["حدث خطأ غير متوقع"];
            this.ErrorCheck = true;
            this.postLoaded = false;
        });
},

        getContacts() {
            Request.fetch(`admin/website_contacts/show`)
                .then((response) => {
                    this.contact = response.data.data;
                    this.youtubeImgUrl= response.data.data.youtube_icon,
                    this.snapchatImgUrl= response.data.data.snapchat_icon,
                    this.tiktokImgUrl= response.data.data.tiktok_icon
                })
                .catch((err) => {
                    if (Request.statusIsFaield(err)) {
                        this.$router.push("/login");
                        localStorage.removeItem("token");
                    }
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.form_container {
    background-color: #fff;
    border-radius: 10px;
    margin: 40px auto;
    padding: 70px 100px;
    @media (max-width: 576px) {
        width: 97%;
        padding: 30px;
    }

    form {
        > div {
            margin-bottom: 40px;
            label {
                display: block;
                font-size: 16px;
                color: #717171;
                font-weight: 600;
                margin-bottom: 10px;
            }
            input,
            select {
                border: 1px solid #71717191;
                font-size: 16px;
                padding: 5px 10px;
                border-radius: 10px;
                display: block;
                width: 50%;
            }
        }
        button {
            margin: 30px auto 0 auto;
        }
    }
}

.upload_img{
            display: flex;
            align-items: center;
            margin-bottom: 40px;
            width: 100%;
            span{
                font-size: 16px;
                color: #656565;
                margin-inline-end: 50px;
            }
            .img_container{
                width: 80px;
                height: 80px;
                border-radius: 50%;
                background-color: #FAFAFA;
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
                img{
                    width: 100%;
                }
                .photo_upload{
                    
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    img{
                        width: 70%;
                    }
                }
            }
        }
</style>
